<template>
    <div class="container bg appe" id="sectionone">
        
    <div class="row "> 
        <div class="col-lg-6 col-12 right text-lg-start" v-bind:class="activenav?'active':''">
            <p class="wellcome">
                WELCOME TO SPACE DYNAMIC
            </p>
            <h3 class="we">We Make <span class="one">Digital Ideas</span>& <span class="two">SEO</span> Marketing</h3>
            <p class="mb-4 mt-4" >
                Space Dynamic is a professional looking HTML template using a Bootstrap 5 (beta 2). This CSS template is free for you
                provided by 
            </p>
            <form action="">
                <div class="foom">
                    <input type="text" placeholder="Your Website URL">
                    <button>Analyze Site</button>
                </div>
            </form>
        </div>
        <div class="col-lg-6 col-12 left text-lg-end" v-bind:class="activenav?'active2':''">
            <div class="text-lg-end im">
                <img class="img-fluid" src="../assets/banner-right-image.png" alt=""/>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    export default {
    name: 'sectionone',
    data() {
        return {
            activenav: false,
        }
    },
    created() {
        let x = this;
        setTimeout(() => {
            x.activenav = true;
        }, 500);
    },
 
    }
</script>

<style  scoped>
.row{
    margin-top: 130px;
    transition: all .5s;
}
.appe::before {
    content: '';
    position:absolute;
    background-image: url("../assets/baner-dec-right.png");
    background-repeat: no-repeat;
        right: 0;
            top: 100px;
            width: 98px;
            height: 290px;
}
.appe::after {
    content: '';
    background-image: url("../assets/baner-dec-left.png");
    background-repeat: no-repeat;
    position: absolute;
        left: 0;
        top: 100px;
        width: 193px;
        height: 467px;
}
.container-fluid{
    background-image: url('../assets/baner-dec-left.png');
    background-repeat: no-repeat
}
.right{
    position: relative;
    left: -1000px;
    transition: all .5s;
}
.left{
    position: relative;
    right: -130px;
    transition: all .5s;
    opacity: 0;
}
.active2{
    right: 0;
    opacity: 1;
}
.active{
    left:0;
}
.bg{
    width: 100%;
    height: 100%;
    }

.wellcome{
    color: #fe3f40;
    font-size: 17px;
    font-weight: 600;
}
.we{ 
    color:#2a2a2a;
    font-size: 60px;
    font-weight: 600;
}
.we .one{
    color: #03a4ed;
}
.we .two{
    color:#fe3f40;
}
.foom{
    background-color: #03a4ed;
    padding: 10px 5px;
    border-radius: 30px
}
.foom input {
    width: 70%;
    border: none;
    background-color: #03a4ed;
    color: white;
    outline: none
}
.foom input::-webkit-input-placeholder{
    color: white
}
.foom button{
    width: 30%;
    background-color: white;
    color:#fe3f40;
    border: none;
    padding: 10px;
    border-radius: 20px
}
.im{
    width:100%;
}
</style>